import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import withAttr from 'flarum/common/utils/withAttr';

import Coloris from '@melloware/coloris';

function strToRgba(str)
{
    const regex = /^((rgba)|rgb)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i;
    let match, rgba;

    // Default to black for invalid color strings
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = '#000';

    // Use canvas to convert the string to a valid color string
    ctx.fillStyle = str;
    match = regex.exec(ctx.fillStyle);

    if (match) {
        rgba = {
            r: match[3] * 1,
            g: match[4] * 1,
            b: match[5] * 1,
            a: match[6] * 1
        };

    } else {
        match = ctx.fillStyle.replace('#', '').match(/.{2}/g).map(h => parseInt(h, 16));
        rgba = {
            r: match[0],
            g: match[1],
            b: match[2],
            a: 1
        };
    }

    return rgba;
}

function rgbaToHex(rgba)
{
    let R = rgba.r.toString(16);
    let G = rgba.g.toString(16);
    let B = rgba.b.toString(16);
    let A = (rgba.a * 255 | 0).toString(16);

    if (rgba.r < 16) {
        R = '0' + R;
    }

    if (rgba.g < 16) {
        G = '0' + G;
    }

    if (rgba.b < 16) {
        B = '0' + B;
    }

    if ((rgba.a * 255 | 0) < 16) {
        A = '0' + A;
    }

    return '#' + R + G + B + A;
}

function rgbaToStr(rgba)
{
    return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
}

export default class Colorbox extends Component {
    oninit(vnode) {
        super.oninit(vnode);

        this.value = strToRgba(this.attrs.value);

        Coloris.init();
    }

    oncreate(vnode) {
        super.oncreate(vnode);

        const element = vnode.dom.children[1];

        document.addEventListener('fofnightmodechange', this.init.bind(this, element));

        this.init(element);
    }

    init(element)
    {
        const fofNightModes = {
            0: 'auto',
            1: 'light',
            2: 'dark'
        };

        Coloris({
            theme: 'polaroid',
            themeMode: fofNightModes[app.session.user.preferences().fofNightMode],
            alpha: true,
            format: 'hex',
            forceAlpha: true,
            wrap: false,
            el: element
        });
    }

    view() {
        return (
            <div className="Colorbox">
                <input type="text" value={rgbaToHex(this.value)} onchange={withAttr('value', this.oninput.bind(this))} aria-label="color-input" required />
                <button style={"color:"+rgbaToStr(this.value)} value={rgbaToHex(this.value)} oninput={withAttr('value', this.oninput.bind(this))} onchange={withAttr('value', this.onchange.bind(this))} aria-label="color-picker" />
            </div>
        );
    }

    oninput(value)
    {
        this.value = strToRgba(value);
        if (this.attrs.oninput) this.attrs.oninput(value);
    }

    onchange(value)
    {
        this.value = strToRgba(value);
        if (this.attrs.onchange) this.attrs.onchange(value);
    }
}
